import Service from '../../../components/Systema/Service';
import config from '../../../config';

export const clienteService = new Service(
  `${config.api_path}/v1/transparencia/clienteglobal`
);

const service = new Service(`${config.api_path}/v1/global/notification`, {
  params: {
    scope: 'manage',
  },
});

export default service;
